import Box from "@mui/material/Box";
import SearchField from "../../SearchField.tsx";
import type { TextSpec } from "../specs.ts";

interface TextEditorProps {
  spec: TextSpec;
  value: string;
  onChange: (value: string) => void;
  onDone: () => void;
}

/** One text field; Enter closes the popover (the value settles on its own). */
export default function TextEditor({ spec, value, onChange, onDone }: TextEditorProps) {
  return (
    <Box
      sx={{ p: 1.5 }}
      onKeyDown={(e) => {
        // preventDefault: the Enter would otherwise reach the pill that gets
        // focus back as the popover closes, and open it again.
        if (e.key === "Enter") {
          e.preventDefault();
          onDone();
        }
      }}
    >
      <SearchField
        value={value}
        onChange={onChange}
        placeholder={spec.placeholder ?? `${spec.label} contains…`}
        icon={false}
        clearable
        autoFocus
        fullWidth
      />
    </Box>
  );
}
